import { useMutation } from '@tanstack/react-query';
import { SUBMISSION_REQUEST_STATUSES } from '../../utils/types';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const modifySubmissionRequest = async (
  id: string,
  body: { status: SUBMISSION_REQUEST_STATUSES }
) => {
  const res = await apiManager.patch(`/admin/request/${id}/modify`, body);
  return res;
};



export const useModifySubmissionRequest = () =>
  useMutation({
    mutationFn: async ({ id, status }: { id: string; status: SUBMISSION_REQUEST_STATUSES }) => {
      const res = await apiClient.patch(ENDPOINTS.SUBMISSION_REQUEST.MODIFY_REQUEST(id), { status });
      return res.data;
    },
  });